import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, Group, Paper, SimpleGrid, Stack, Text, TextInput } from '@mantine/core'
import { useSelector } from 'react-redux'
import { addProductLanguage, getProductLanguage } from '../../../../services/products'
import { notificationError, notificationSuccess } from '../../../ui/Notifications'
import { getAllLanguagesList } from '../../../../services/languages'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { 
  ClassicEditor, 
  Bold, 
  Essentials, 
  Italic, 
  Mention, 
  Paragraph, 
  Undo, 
  Font, 
  Heading,
  List,
  Alignment,
  Link,
  PasteFromOffice,
  ImageInsertViaUrl,
  Image,
  ImageInsert,  Table, TableToolbar,
} from 'ckeditor5'

const defaultForm = {
  option: []
}

// description input config
const configEditor = {
  plugins:[
    Bold,
    Essentials,
    Italic,
    Mention,
    Paragraph,
    Undo,
    Font,
    Heading,
    List,
    Alignment,
    Link,
    PasteFromOffice,
    ImageInsertViaUrl,
    Image,
    ImageInsert,
    Table, TableToolbar,
  ],
  alignment: {
    options: [ 'left', 'right' ]
  },
  fontSize: {
    options: [
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22
    ],
    supportAllValues: true
  },
  list: {
    properties: {
      styles: true,
      startIndex: true,
      reversed: true
    }
  },
  link: {
    decorators: {
      addTargetToExternalLinks: {
        mode: 'automatic',
        callback: url => /^(https?:)?\/\//.test( url ),
        attributes: {
            target: '_blank',
            rel: 'noopener noreferrer'
        }
      }
    }
  }, 
  toolbar: {
    items: [
      'undo', 'redo',
      '|',
      'heading',
      '|',
      'fontSize', 'Bold', 'Italic', 'alignment',
      '|',
      'link',
      '|',
      'bulletedList', 'numberedList',
      '|',
      'insertImage',
      '|',
      'insertTable'
    ],
    shouldNotGroupWhenFull: true
  },
  initialData: ''
}

const ProductLanguage = ({ productId, reloadProduct }) => {
  const { isLoadingProduct, variants } = useSelector(state => state.product_detail)
  const [formData, setFormData] = useState(defaultForm)

  // language
  const [allLanguages, setAllLanguages] = useState([])
  // language product
  const [listLanguageProduct, setListLanguageProduct] = useState({})

  // variant language
  const [variantLanguage, setVariantLanguage] = useState([])

  // service
  const [loadingSubmit, setLoadingSubmit] = useState(false)

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }
  const handleChangeLanguageNameVariant = (indexVariant, val) => {
    const form = JSON.parse(JSON.stringify(formData.option))
    form[indexVariant].language_name = val
    handleChangeForm('option', form)
  }
  const handleChangeLanguageNameVariantOption = (indexVariant, indexOption, val) => {
    const form = JSON.parse(JSON.stringify(formData.option))
    form[indexVariant].attributes[indexOption].language_value = val
    handleChangeForm('option', form)
  }

  const getAllLanguages = async () => {
    try {
      const response = await getAllLanguagesList()
      const dataLanguage = response.data
      const remap = dataLanguage.reduce((acc, curr) => {
        // Exclude languages with id 4 (english) and 5 (Chinese)
        if (curr.attributes.id !== 4 && curr.attributes.id !== 5) {
          acc.push({ ...curr.attributes })
        }
        return acc
      }, [])
      setAllLanguages(remap)
    } catch (error) {
      console.error('Error fetching languages:', error)
    }
  }

  const getProductLanguages = async () => {
    try {
      const response = await getProductLanguage(productId)
      setListLanguageProduct(response.message)
    } catch (error) {
      console.error('Error fetching product languages:', error)
    }
  }

  const setVariantsOrigin = () => {
    const _variants = JSON.parse(JSON.stringify(variants.origin))

    setVariantLanguage(_variants)
  }

  const insertState = (value) => {
    const idLanguage = value.id
    const val = listLanguageProduct[idLanguage]

    const resetVariantLanguage = variantLanguage.map((variant) => {
      return {
        ...variant,
        language_name: '',
        attributes: variant.attributes.map((attribute) => {
          return {
            ...attribute,
            language_value: '',
          }
        }),
      }
    })

    if (val === undefined) {
      const form = {
        id: idLanguage,
        title: '',
        description: '',
        language: value.name,
        option: resetVariantLanguage
      }
      setFormData(prevState => ({ ...prevState, ...form }))
    }
    else {
      const form = {
        id: idLanguage,
        title: val.title || '',
        description: val.description || '',
        language: val.language,
        option: resetVariantLanguage,
      }

      setFormData(prevState => ({ ...prevState, ...form }))

      if (val.options.length > 0) {
        const valueOption = val.options
        const dataOption = formData.option
        for (let i = 0; i < valueOption.length; i++) {
          for (let j = 0; j < dataOption.length; j++) {
            if (valueOption[i].id === dataOption[j].key_id) {
              dataOption[j].language_name = valueOption[i].name
              const valueVariantOption = valueOption[i].values
              const dataVariantOption = dataOption[j].attributes
              for (let k = 0; k < valueVariantOption.length; k++) {
                for (let l = 0; l < dataVariantOption.length; l++) {
                  if (valueVariantOption[k].id === dataVariantOption[l].id) {
                    dataVariantOption[l].language_value = valueVariantOption[k].value
                  }
                }
              }
            }
          }
        }

        setFormData(prevState => ({ ...prevState, option: dataOption }))
      }
    }
  }

  function getAllData () {
    console.log(' get all data language')
    getAllLanguages()
    getProductLanguages()
  }

  useEffect(() => {
    if (allLanguages.length !== 0) {
      insertState(allLanguages[0])
    }
    // eslint-disable-next-line
  }, [allLanguages, listLanguageProduct])

  useEffect(() => {
      getAllData()
    // eslint-disable-next-line
  }, [variantLanguage])

  useEffect(() => {
    if (!isLoadingProduct && variants) {
      setVariantsOrigin()
    }
    // eslint-disable-next-line
  }, [isLoadingProduct, variants])


  // service
  const generatePayload = () => {
    const dataOption = []
    const variantOption = []
    const valOption = formData.option
    for(let i = 0; i < valOption.length; i++) {
      if (valOption[i].language_name !== undefined) {
        const data = {
        id : valOption[i].key_id,
        key: 'name',
        value: valOption[i].language_name
        }
        dataOption.push(data)
      }
      const variant = valOption[i].attributes
      variant.forEach((value) => {
        const variantData = {
          id : value.id,
          key: 'value',
          value: value.language_value
        }
        if (value.language_value !== undefined) {
          variantOption.push(variantData)
        }
      })
    }
    const body = {
      languages: [
        {
          id: formData.id,
          product: [],
          options: dataOption,
          option_values: variantOption
        }
      ]
    }

    const languages = body.languages
    languages.forEach((language) => {
      const languagesProduct = language.product

      const dataTitle = {
        key: 'title',
        value: formData.title !== undefined && formData.title !== '' ? formData.title : ''
      }
      languagesProduct.push(dataTitle)

      const dataDescription = {
        key: 'description',
        value: formData.description !== undefined && formData.description !== '' ? formData.description : ''
      }
      languagesProduct.push(dataDescription)
    })
    return body
  }

  const handleSubmit = async () => {
    try {
      setLoadingSubmit(true)
      const payload = generatePayload()
      const response = await addProductLanguage(productId, payload)
      if (response.success) {
        notificationSuccess('Success', 'Update Product Language Success')
        await getProductLanguages()
        reloadProduct()
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Please contact your administrator'
      notificationError('Update Product language Error', errorMessage)
    } finally {
      setLoadingSubmit(false)
    }
  }

  const renderButtonUpdate = () => {
    const buttonStyle = {
      position: 'fixed',
      bottom: '25px',
      right: '55px',
      padding: '10px',
      zIndex: 1000,
    }
    return (
      <Button
        size='sm'
        style={buttonStyle}
        loading={loadingSubmit}
        loaderProps={{ type: 'dots' }}
        onClick={() => handleSubmit()}
      >
        Update
      </Button>
    )
  }

  const mappingTabCountries = (countries) => countries.map((val, index) => {
    return (
      <Paper
        key={index}
        radius="lg"
        withBorder
        py={4}
        px='lg'
        style={{ cursor: 'pointer' }}
        bg={ val.name === formData.language ? 'gray.3' : 'white' }
        onClick={() => insertState(val)}
      >
        <Text size="sm">{val.name}</Text>
      </Paper>
    )
  })

  const mappingVariants = (formDataVariants) => formDataVariants.map((variant, indexVariant) => {
    const mappingOptionName = (options) => options.map((options, indexOption) => {
      return (
        <TextInput
          key={indexOption}
          value={formDataVariants[indexVariant].attributes[indexOption].value}
          label="English Variant Options"
          placeholder="Input Here"
          disabled
        />
      )
    })
    const mappingLanguageOptionValue = (options) => options.map((options, indexOption) => {
      return (
        <TextInput
          key={indexOption}
          value={formDataVariants[indexVariant].attributes[indexOption].language_value}
          label={`${formData.language} Variant Options`}
          placeholder="Input Here"
          onChange={(event) => handleChangeLanguageNameVariantOption(indexVariant, indexOption, event.currentTarget.value)}
        />
      )
    })

    return (
      <SimpleGrid key={indexVariant} cols={4} spacing="xl" verticalSpacing="xl">
        <TextInput
          value={formDataVariants[indexVariant].name}
          label="English Variant Name"
          placeholder="Input Here"
          disabled
        />

        <TextInput
          value={formDataVariants[indexVariant].language_name}
          label={`${formData.language} Variant Name`}
          placeholder="Input Here"
          onChange={(event) => handleChangeLanguageNameVariant(indexVariant, event.currentTarget.value)}
        />

        <Stack>
          {mappingOptionName(variant.attributes)}
        </Stack>

        <Stack>
          {mappingLanguageOptionValue(variant.attributes)}
        </Stack>
      </SimpleGrid>
    )
  })

  const renderVariants = () => {
    if (formData.option.length !== 0) {
      return (
        <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
          <Text fw={500}>
            {`Variant ${formData.language} Language`}
          </Text>
          <Divider my={10} />
          <Stack>
            {mappingVariants(formData.option)}
          </Stack>
        </Paper>
      )
    }
  }
  return (
    <Box mb={20} mt={10}>
      <Group mt={'xl'}>
        {mappingTabCountries(allLanguages)}
      </Group>
      <Divider my="md" />

      <Paper my={'xl'} p={'md'} withBorder shadow="xs" radius="md">
        <Stack style={{ width: '75%'}} gap={'lg'}>
          <TextInput
            value={formData.title}
            label={`Product ${formData.language} Title`}
            onChange={(val) => handleChangeForm('title', val.target.value)}
          />

          <Box>
            <Text size="sm" fw={500}>
              {`Product ${formData.language} Description`}
            </Text>
            <CKEditor
              editor={ClassicEditor}
              config={configEditor}
              data={formData.description}
              onReady={(editor) => {
                editor.execute('fontSize', { value: '12px' })
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    'height',
                    '250px',
                    editor.editing.view.document.getRoot()
                  )
                })
              }}
              onChange={( event, editor ) => {
                editor.execute('fontSize', { value: '12px' })
                const valueEditor = editor.getData()
                handleChangeForm('description', valueEditor)
              }}
            />
          </Box>
        </Stack>
      </Paper>

      {renderVariants()}

      {renderButtonUpdate()}
    </Box>
  )
}

export default ProductLanguage